export default __webpack_public_path__ + "static/media/FB.b1bfe5d4.svg";